import { render } from "./ChangePassword.vue?vue&type=template&id=3268e10b"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=3268e10b&lang=css"
script.render = render

export default script